import React from "react";
import "./Faq.css";

const FAQ = () => {
  return (
    <div className="faq-container">
      <h1 className="faq-title">Preguntas Frecuentes</h1>
      <div className="faq-content">
        <div className="faq-item">
          <h3 className="faq-question">¿Cómo puedo registrarme en la plataforma?</h3>
          <p className="faq-answer">
            Registrarte es muy sencillo. Solo debes hacer clic en el botón "Registrarse", completar el formulario con tus datos, luego desde "oficina" o desde "mi cuenta" completa los datos que te faltan y elegi si deseas ofrecer servicios, solicitar servicios, o ambos. Una vez registrado, podrás acceder a todas las funcionalidades de la plataforma.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">¿Cómo solicito un servicio?</h3>
          <p className="faq-answer">
            Para solicitar un servicio, simplemente ve al formulario en la página de inicio, selecciona la categoría del servicio que necesitas, y completa los detalles requeridos. Tu solicitud será enviada a los profesionales registrados en esa categoría, quienes te enviarán presupuestos.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">¿Cuántos presupuestos puedo recibir?</h3>
          <p className="faq-answer">
            Podrás recibir hasta 5 presupuestos de los profesionales que respondan primero a tu solicitud. Esto garantiza que puedas comparar diferentes opciones y elegir la que mejor se adapte a tus necesidades.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">¿Dónde puedo ver las solicitudes de servicios?</h3>
          <p className="faq-answer">
            Si eres un profesional registrado, puedes ver las solicitudes de servicios desde la sección "Solicitudes" en tu oficina virtual. Allí tendrás acceso a todas las solicitudes pendientes y podrás enviar tus presupuestos directamente desde la plataforma.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">¿Cómo funciona la carga y el uso de currículums en formato de video?</h3>
          <p className="faq-answer">
            Puedes cargar tu currículum en formato de video desde tu perfil. Estos videos son visibles para las empresas que publican vacantes en la plataforma. Si aplicas a una vacante, la empresa podrá ver tu video y ponerse en contacto contigo si tu perfil es aplicable.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">¿Cómo puedo compartir mi currículum?</h3>
          <p className="faq-answer">
            Una vez cargado tu currículum en la plataforma, puedes generar un enlace único para compartirlo con empresas o contactos externos. Esto permite que otras personas vean tu experiencia y habilidades sin necesidad de estar registradas en la plataforma.
          </p>
        </div>

        <div className="faq-item">
          <h3 className="faq-question">¿Qué debo hacer si tengo problemas o dudas?</h3>
          <p className="faq-answer">
            Si tienes alguna duda o encuentras un problema, puedes contactarnos a través del chat en vivo, enviarnos un correo electrónico, o utilizar el formulario de contacto disponible en el sitio. Nuestro equipo está listo para ayudarte.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
